<template>
    <li class="pb-2">
        <div
                :class="{bold: isFolder}"
                :style="padding"
                class="flex justify-between leading-normal"
        >
            <div class="flex-no-shrink pr-2 text-blue-dark">
                <a class="cursor-pointer text-grey" @click="toggleOpen" v-show="isFolder">
                    <i class="fa fa-fw"
                       :class="{'fa-caret-right': !open, 'fa-caret-down': open}" v-show="!isLoading"></i>
                    <i class="fa fa-fw fa-circle-o-notch fa-spin" v-show="isLoading"></i>
                </a>
                <i v-show="!isFolder" class="fa fa-fw"></i>
                <a v-show="selectable" class="cursor-pointer" @click="toggleSelect">
                    <i
                            class="fa fa-fw"
                            :class="{
                            'fa-square-o': !isSelected && !isHalfSelected,
                            'fa-check-square': isSelected,
                            'fa-square': isHalfSelected
                            }"
                    ></i>
                </a>
            </div>
            <div class="flex-1" style="hyphens: auto;">
                <a v-show="!isFolder" class="cursor-pointer hover:text-blue-darkest" @click="toggleSelect">
                    {{ model.text }}
                </a>
                <span v-show="isFolder">
                    {{ model.text }}
                </span>
            </div>

        </div>

        <ul v-show="isFolder" class="pt-2 list-reset">
            <transition-expand>
                <div class="pt-2" v-if="open && children.length > 0">
                    <database-filter-item
                            v-for="item in children"
                            :model="item"
                            :key="item.id"
                            :depth="depth + 1"
                            :parent-path="path"
                            :folder-select="folderSelect"
                            :codes="codes"
                            @deselect="deselectedChild"
                    >
                    </database-filter-item>
                    <div class="flex justify-center" v-show="hasNext || hasPrevious">
                        <a class="block cursor-pointer text-blue-dark mx-4" @click="previous" v-show="hasPrevious">
                            <i class="fa fa-chevron-left"></i> previous
                        </a>
                        <a class="block cursor-pointer text-blue-dark mx-4" @click="next" v-show="hasNext">
                            next <i class="fa fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </transition-expand>
        </ul>

    </li>
</template>

<script>

    import FilterItemMixin from "./FilterItemMixin.vue";
    import TransitionExpand from "../TransitionExpand";

    export default {

        components: {
            TransitionExpand
        },

        name: 'database-filter-item',

        inject: ['tree'],

        mixins: [FilterItemMixin],

        props: {
            codes: Object,
            model: Object,
            depth: {
                type: Number,
                default: 0,
            },
            parentPath: {
                type: Array,
                default: () => [],
            },
            folderSelect: {
                type: Boolean,
                required: true,
            }
        },

        created() {
            if (Array.isArray(this.model.children)) {
                this.loaded = true;
            }
        },

        watch: {
            'codes.selected': function () {
                this.updateRequiredState();
            },
            'open': function () {
                this.updateRequiredState();
            },
        },

        methods: {
            updateRequiredState() {// only folders are required!
                if (!this.isFolder) {
                    return;
                }
                if (this.isHalfSelected || this.open) {
                    if (!_.includes(this.tree.required, this.model.id)) {
                        this.tree.required.push(this.model.id);
                    }
                } else {
                    // remove itself
                    if (_.includes(this.tree.required, this.model.id)) {
                        let that = this;
                        this.tree.required = _.filter(this.tree.required, function (item) {
                            return item !== that.model.id;
                        });
                    }

                    this.closeChildren(this.model);
                }
            },
            closeChildren(model) {
                this.close(model);
                let that = this;
                this.getAllChildren(model).forEach(function (child) {
                    that.close(child);
                });
            },
            toggleSelect: function () {
                if (this.isSelected) {
                    // inform parent!
                    this.$emit('deselect');

                    // deselect all children!
                    this.deselectWithChildren(this.model);

                    return;
                }

                this.deselectWithChildren(this.model);

                this.codes.selected.push(this.model);
            },
            deselectWithChildren: function (item) {
                if (this.isInList(item.id)) {
                    this.codes.selected = this.codes.selected.filter(function (selected) {
                        return selected.id !== item.id;
                    });
                }

                let that = this;
                this.getChildren(item)
                    .forEach(function (item) {
                        that.deselectWithChildren(item);
                    });
            },
            getChildrenIds: function (item) {
                if (!Array.isArray(item.children)) {
                    return [item.id];
                }

                let result = [];

                let that = this;

                item.children.forEach(function (item) {
                    result = result.concat(that.getChildrenIds(item));
                });

                return result.concat([item.id]);
            },
            deselectedChild: function () {
                // if we or our parent is selected...
                if (this.isSelected) {
                    this.$emit('deselect');
                }
                // a child was deselected.

                if (!this.isSelected) {
                    return;
                }

                // we deselect us
                // if we are selected, we deselect us
                let that = this;
                this.codes.selected = this.codes.selected.filter(function (item) {
                    return item.id !== that.model.id;
                });

                // now select all children!

                //this.model.children.forEach(function (item) {
                this.children.forEach(function (item) {
                    that.codes.selected.push(item);
                });
            },
            toggleOpen: function () {
                if (!this.open) {
                    this.tree.opened.push(this.model.id);
                } else {
                    this.close(this.model);
                }

            },
            close: function (model) {
                this.tree.opened = this.tree.opened.filter(function (item) {
                    return item !== model.id;
                });
            }
        }

    }

</script>
